<template>
  <div class="main">
    <report-top>
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><!-- <Button @click="openAdd" type="primary" class="chaxun">新增</Button> -->
        <Button type="primary" @click="daochubiaoge(searchItem)" class="chaxun">导出表格</Button>
        <Button type="success" @click="taitou()" class="chaxun">导出对账单</Button>

      </template></selectTool>

    <Table show-summary border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(240)" @on-expand="expand">
      <template slot-scope="{ row, index }" slot="auditorTwo">
        <Button size="small" v-if="row.auditorTwo == null" @click="openShenhe(row, index)">审核</Button>
        <span v-else>{{ row.auditorTwo }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="shoufu">
        <yingshouForm :data='row' @finish='getList'></yingshouForm>
      </template>
      <template slot-scope="{ row, index }" slot="kaipiao">
        <Button @click="kaipiao(row)" v-if="row.ticketStatus == 0">开票</Button>
        <span v-else>已开票</span>
      </template>
      <template slot-scope="{ row, index }" slot="imgPathArr">
        <viewer v-if="row.imgPathArr">
          <img v-for="(x, index) in row.imgPathArr" :key="index" :src="axios.platConfig.fileUri + x" width="24"
            height="24" style="margin-right: 4px; cursor: pointer" />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openUpdateStatus(row, index)">状态</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增数据' : '编辑数据'" width="1000" ref="formModel">
      <Input v-model="item.ono" placeholder="请选择" slot="ono" @on-focus="openForm = true"></Input>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="财务二次审核" width="400" ref="shenhe">
      <Button slot="btn" type="primary" @click="shenhe">提交审核</Button>
    </form-model>

    <Modal v-model="openForm" title="订单号" footer-hide width="1000">
      <dingdanhao :scan="true" @obj="
        item.ono = $event.no;
      openForm = false;
      "></dingdanhao>
    </Modal>
    <form-model title="更新收款状态" width="400" ref="updateStatus">
      <Button slot="btn" type="primary" @click="updateStatus">提交表单</Button>
    </form-model>

    <taitou ref="taitou"></taitou>
    <kaipiaoguanli v-show="false" ref="kaipiaoguanli"></kaipiaoguanli>
  </div>
</template>
<script>
var kehuitems = [];
import dingdanhao from "../fahuo/xitongkaidan.vue";
import taitou from "./taitou.vue";
import kaipiaoguanli from "./kaipiaoguanli.vue";
import yingshouChildList from "./yingshouChildList.vue";
import yingshouForm from "./yingshouForm.vue";
export default {
  components: {
    dingdanhao,
    taitou,
    kaipiaoguanli,
    yingshouChildList,
    yingshouForm,
  },
  data() {
    return {
      isAdd: false,
      openForm: false,
      columns: [
        {
          type: "expand",
          width: 70,
          align: "center",
          render: (h, data) => {
            var that = this;
            return h(yingshouChildList, {
              //局部注册组件不需要加引号
              props: {
                data: data.row.ordersChargesList,
                columns: this.ordersChargesListForms,
              },
              on: {
                finish(e) {
                  that.getList();
                },
              },
            });
          },
        },
        {
          title: "状态",
          key: "status2",
          sort: 3.2,
        },
        {
          title: "二次审核人",
          slot: "auditorTwo",
          sort: 3.3,
        },
        {
          title: "所属主体",
          key: "company",
          sort: 3.4,
        },
        {
          title: "结算方式",
          key: "settletype",
          sort: 3.4,
        },
        {
          title: "月份",
          key: "orderCreateTime2",
          sort: 3.4,
        },
        {
          title: "到期日期",
          key: "lastPayDate2",
          sort: 3.4,
        },
        {
          title: "回款日期",
          key: "da2",
          sort: 3.4,
        },
        {
          title: "已收总金额",
          key: "moneyReal",
          slot: 'shoufu',
          sort: 3.5,
        },
        {
          title: "开票信息",
          slot: "kaipiao",
          width: 100,
          sort: 6,
        },
        /* {
          title: "操作",
          slot: "action",
          width: 200,
          align: "center",
          fixed: "right",
          sort: 50,
        }, */
      ],
      tableData: [],
      item: {
        cid: "",
        customer: "",
        ono: "",
        no: "",
        contact: "",
        tel: "",
        carType: "",
        tradeType: "",
        bpMode: 0,
        money: 0,
        currency: "",
        saleman: "",
        salemanAccount: "",
        imgPath: "",
        imgPathArr: "",
        processTime: "",
        remark: "",
      },
      forms: [
        {
          title: "订单号",
          key: "ono",
          required: "true",
          width: 150,
          slotForm: "ono",
        },
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          val: "",
          type: "Select",
          selectType: "obj",
          selectItems: kehuitems,
        },
        {
          title: "客户单号",
          key: "customerNo",
        },
        {
          title: "应收总金额（人民币）",
          key: "money",
          //key: "receive_amount_foreign",
          required: "true",
          val: 0,
          type: "InputNumber",
        },
        {
          title: "应付总金额（人民币）",
          key: "payableMoney",
          //key: "receive_amount_foreign",
          required: "true",
          val: 0,
          type: "InputNumber",
        },
        {
          title: "币别",
          key: "currency",
          required: "true",
          val: "",
          type: "Select",
          selectItems: this.lydic.getA("mType"),
        },
        {
          title: "账单号",
          key: "no",
          required: false,
          val: "",
          type: "Input",
        },

        {
          title: "联系人",
          key: "contact",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "税率",
          key: "taxRate",
        },
        {
          title: "贸易类型",
          key: "tradeType",
          required: "true",
          val: "",
          type: "Select",
          selectItems: ["进口", "出口"],
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: "true",
          val: 0,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
        },

        {
          title: "业务员",
          key: "salemanAccount",
          key1: "saleman",
          required: false,
          val: "",
          type: "selectUser",
        },
        {
          title: "票据上传",
          key: "imgPathArr",
          slot: "imgPathArr",
          required: false,
          val: "",
          type: "lyPhoto",
        },
        {
          title: "付款日期",
          key: "processTime",
          key2: "processTime2",
          required: false,
          width: 130,
          type: "lyyymmdd",
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      shenheItem: {
        id: 0,
        ono: "",
        account: "",
        time: Date.now(),
      },
      shenheForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
          readonly: true,
          span: 24,
        },
        {
          title: "审核人账号",
          key: "account",
          type: "Input",
          readonly: true,
          span: 24,
        },
        /* {
          title: "审核日期",
          key: "time",
          type: "lyyymmdd",
          disabled: true,
          clearabled: false,
          span: 24,
        }, */
      ],

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
        startTime: 0,
        endTime: 0,
        cid: "",
      },
      total: 0,

      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "客户",
          key: "cid",
          selectItems: kehuitems,
          type: "Select",
          selectType: "obj",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
      ],
      ordersChargesListForms: [
        {
          title: "订单号",
          key: "ono",
          width: 150,
        },
        {
          title: "收费项目",
          key: "name",
        },

        {
          title: "领导意见",
          slot: "leaderComment",
          sort: 1.3,
        },
        {
          title: "币别",
          key: "currencyForeign",
        },
        {
          title: "应收（外币）",
          key: "receiveAmountForeign",
        },

        {
          title: "应收（人民币）",
          key: "receiveAmount",
        },
        {
          title: "应付（外币）",
          key: "payAmountForeign",
        },
        {
          title: "应付（人民币）",
          key: "payAmount",
        },
        {
          title: "审核人",
          key: "auditor",
        },
        {
          title: "备注",
          key: "remark",
        },
        {
          title: "费用来源",
          slot: "type",
        },
      ],
      updateStatusItem: {
        status: 0,
        id: "",
      },
      updateStatusForms: [
        {
          title: "收款状态",
          key: "status",
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic.yingshouStatus,
          required: true,
        },
      ],
      nowexpand: [],
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    getList() {
      //记录展开的条目
      var t = this.tableData;
      this.nowexpand = [];
      for (let i = 0; i < t.length; i++) {
        if (t[i]._expanded) {
          this.nowexpand.push(i);
        }
      }
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-fms/accountsReceivable/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log('应收账款', data);
        var type = {
          0: "常规",
          1: "司机上传",
        };
        for (let i = 0; i < data.length; i++) {
          data[i]._expanded = false;
          data[i].index = i;
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
          data[i].status2 = this.lydic.getVal("yingshouStatus", data[i].status);
          data[i].processTime2 = this.utils.time(data[i].processTime, "yymmdd");
          data[i].orderCreateTime2 = this.utils.time(data[i].orderCreateTime, "yymm");
          data[i].da2 = this.utils.time(data[i].da, "yymmdd");
          data[i].lastPayDate2 = this.utils.time(data[i].lastPayDate, "yymmdd");
          data[i].imgPathArr = this.utils.strToJson(data[i].imgPath);
          var ordes = data[i].ordersChargesList;
          for (let j = 0; j < ordes.length; j++) {
            ordes[j].status2 = this.lydic.getVal("status", 1);
            ordes[j].type2 = type[ordes[j].type];
          }
        }
        this.tableData = data;
        //展开之前的条目
        for (let i = 0; i < this.nowexpand.length; i++) {
          this.tableData[i]._expanded = true;
        }
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var aaa = this.utils.findObj(kehuitems, "id", a.cid);
      a.imgPath = this.utils.jsonToStr(a.imgPathArr);
      this.item.customer = aaa.name;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort + "/cloud-tms-server-fms/accountsReceivable/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url:
            this.axios.ipPort +
            "/cloud-tms-server-fms/accountsReceivable/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url:
              this.axios.ipPort +
              "/cloud-tms-server-fms/accountsReceivable/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openShenhe(v) {
      var a = this.axios.user;
      this.shenheItem.ono = v.ono;
      this.shenheItem.id = v.id;
      this.shenheItem.account = a.name;
      this.$refs.shenhe.reach(this.shenheForms, this.shenheItem);
    },
    shenhe(v) {
      var a = this.$refs.shenhe.getItem();
      if (!a) {
        return;
      }
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsReceivable/updateAuditTwo",
        data: this.shenheItem,
      }).then((res) => {
        if (res) {
          this.$refs.shenhe.close();
          this.getList();
        }
      });
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    openUpdateStatus(row) {
      this.updateStatusItem.id = row.id;
      this.updateStatusItem.status = row.status;
      this.$refs.updateStatus.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus(name) {
      var a = this.$refs.updateStatus.getItem();

      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-fms/accountsReceivable/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.updateStatus.close();
          this.getList();
        }
      });
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },

    taitou(v) {
      this.searchItem = this.$refs.selectTool.getItem();
      var v = this.searchItem;
      if (v.cid.length == 0) {
        this.$Message.error("请选择客户");
        return;
      }
      this.$refs.taitou.reach(v);
    },
    kaipiao(v) {
      this.$refs.kaipiaoguanli.reach(v);
    },
    expand(row, t) {
      this.tableData[row.index]._expanded = t;
    },
    daochubiaoge() {
      this.searchItem = this.$refs.selectTool.getItem();
      var params = [

        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(this.axios.ipPort + "/cloud-tms-server-fms/accountsReceivable/exportDetailExcel", params);
    }
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuList();
    //
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/yingshouzhangkuan.vue